<template>
  <el-dialog title="通行时段配置" :visible.sync="visible" width="720px" @close="handleClose">
    <div v-if="machine.machineName" style="margin-bottom: 12px; color: #909399;">
      设备：{{ machine.machineName }}（业主/员工分别配置通行时段；某类不配则默认全天）
    </div>

    <div v-for="group in groups" :key="group.type" style="margin-bottom: 18px;">
      <div style="font-weight: 600; margin-bottom: 8px;">{{ group.label }}</div>
      <div v-for="(slot, idx) in group.slots" :key="idx" style="margin-bottom: 8px;">
        <el-time-picker
          is-range
          v-model="slot.range"
          value-format="HH:mm"
          format="HH:mm"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          style="width: 280px;" />
        <el-button type="danger" size="mini" icon="el-icon-delete" circle style="margin-left: 8px;"
                   @click="group.slots.splice(idx, 1)" />
      </div>
      <el-button size="mini" type="primary" plain icon="el-icon-plus" @click="group.slots.push({ range: null })">
        添加时段
      </el-button>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" :loading="submitLoading" @click="handleSave">保存并下发</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { listAccessControlTime, saveAccessControlTime } from '@/api/property/accessControlApi'

export default {
  name: 'AccessControlTime',
  data() {
    return {
      visible: false,
      submitLoading: false,
      machine: {},
      groups: [
        { type: '1', label: '业主时段', slots: [] },
        { type: '0', label: '员工时段', slots: [] }
      ]
    }
  },
  methods: {
    open(machine) {
      this.machine = machine || {}
      this.groups.forEach(g => { g.slots = [] })
      this.visible = true
      this.loadConfig()
    },
    async loadConfig() {
      if (!this.machine.machineId) return
      try {
        const res = await listAccessControlTime({
          machineId: this.machine.machineId,
          communityId: this.machine.communityId
        })
        const slots = (res && res.timeSlots) || []
        // 按人员类型分组：hours "07:00-09:00" -> range ['07:00','09:00']
        slots.forEach(s => {
          const range = this.parseHours(s.hours)
          if (!range) return
          const type = s.personType === '0' ? '0' : '1' // 缺省归业主
          const group = this.groups.find(g => g.type === type)
          if (group) group.slots.push({ range })
        })
        // 两类都为空时各给一行空时段，方便编辑
        this.groups.forEach(g => { if (g.slots.length === 0) g.slots.push({ range: null }) })
      } catch (e) {
        this.groups.forEach(g => { g.slots = [{ range: null }] })
      }
    },
    parseHours(hours) {
      if (!hours || typeof hours !== 'string') return null
      const parts = hours.split('-')
      if (parts.length !== 2) return null
      const start = (parts[0] || '').trim()
      const end = (parts[1] || '').trim()
      if (!start || !end) return null
      return [start, end]
    },
    async handleSave() {
      const timeSlots = []
      this.groups.forEach(g => {
        g.slots.forEach(slot => {
          if (!slot.range || slot.range.length !== 2 || !slot.range[0] || !slot.range[1]) return
          timeSlots.push({
            personType: g.type,
            hours: slot.range[0] + '-' + slot.range[1],
            isOpen: '1'
          })
        })
      })
      this.submitLoading = true
      try {
        await saveAccessControlTime({
          machineId: this.machine.machineId,
          communityId: this.machine.communityId,
          timeSlots
        })
        this.$message.success('时段已保存并下发到设备')
        this.visible = false
        this.$emit('success')
      } catch (e) {
        this.$message.error(e && e.message ? e.message : '保存失败')
      } finally {
        this.submitLoading = false
      }
    },
    handleClose() {
      this.machine = {}
    }
  }
}
</script>
